import { Controller } from "@hotwired/stimulus"
import * as echarts from 'echarts';

export default class extends Controller {
  static values = {
    options: Object
  }

  connect() {
    if (this.hasOptionsValue) {
      this.chart = echarts.init(this.element);
      this.chart.setOption(this.optionsValue);
      this.resizeObserver = new ResizeObserver(() => {
        window.setTimeout(() => this.chart.resize(), 10);
        window.setTimeout(() => this.chart.resize(), 500);
      });
      this.resizeObserver.observe(this.element);
    }
  }

  disconnect() {
    if (this.resizeObserver) {
      this.resizeObserver.unobserve(this.element);
      this.resizeObserver.disconnect();
    }
    if (this.chart) {
      this.chart.dispose();
    }
  }
}
